import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchExpertReviews, getExpertReviews, getReviewsStatus } from '../store';

export function useExpertReviews(expertId: string, params: Partial<{ skip: boolean }> = {}) {
  const { skip } = params;

  const dispatch = useDispatch();

  const loadingStatus = useSelector(getReviewsStatus);
  const reviews = useSelector(getExpertReviews);

  useEffect(() => {
    if (skip) return;

    dispatch(fetchExpertReviews(expertId));
  }, [dispatch, expertId, skip]);

  return {
    reviews,
    loadingStatus,
  };
}
